import { Link } from 'react-router-dom';
import { blogs } from '../../../data/blogs';

export default function HomeBlogSection() {
  // Get the 3 most recent blogs
  const recentBlogs = blogs.slice(0, 3);

  return (
    <section className="py-20 bg-gray-50 dark:bg-gray-800 transition-colors duration-300 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-64 h-64 bg-[#e18033] rounded-full mix-blend-multiply filter blur-3xl opacity-50 animate-blob"></div>
        <div className="absolute top-0 left-0 w-64 h-64 bg-[#0d9488] rounded-full mix-blend-multiply filter blur-3xl opacity-50 animate-blob animation-delay-2000"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6">
            Latest from our <span className="text-[#e18033]">Blog</span>
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-400 max-w-3xl mx-auto">
            Stay updated with our latest industry insights, tips, and news.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {recentBlogs.map((blog) => (
            <Link 
              to={`/blog/${blog.slug}`} 
              key={blog.id}
              className="group bg-white dark:bg-gray-900 rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 flex flex-col border border-gray-100 dark:border-gray-800"
            >
              <div className="h-48 overflow-hidden">
                <img 
                  src={blog.coverImage} 
                  alt={blog.title} 
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="p-6 flex flex-col flex-grow">
                <div className="flex items-center text-sm text-gray-500 dark:text-gray-400 mb-3 space-x-4">
                  <span className="flex items-center"><i className="ri-calendar-line mr-1"></i> {blog.date}</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3 group-hover:text-[#e18033] transition-colors">
                  {blog.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-400 mb-4 flex-grow line-clamp-3">
                  {blog.excerpt}
                </p>
                <div className="text-[#e18033] font-medium flex items-center group-hover:translate-x-2 transition-transform mt-auto">
                  Read More <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link 
            to="/blogs"
            className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-xl text-white bg-[#e18033] hover:bg-[#c96a24] transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1"
          >
            View All Blogs <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
